import { de, enGB, fi, da, nb, sv, es, fr } from "date-fns/locale";
import { Locale } from "date-fns";
import { Domains } from "@/core/types/types";

/**
 * US locale is the only which shows the calendar starting with
 * Sunday
 * In regards FR-3556 all calendars should start from Monday and
 * as GB and US has same language, we share GB locale between
 * both .NET and .COM Domains as a workaround
 */
const locales: {
  [key in keyof typeof Domains as string]: Locale;
} = {
  [Domains.DE]: de,
  [Domains.NET]: enGB,
  [Domains.COM]: enGB,
  [Domains.NO]: nb,
  [Domains.DK]: da,
  [Domains.SE]: sv,
  [Domains.FI]: fi,
  [Domains.ES]: es,
  [Domains.AT]: de,
  [Domains.FR]: fr,
};

const getDatePickerLocale = (tld: Domains): Locale =>
  locales[tld] || locales.net;

export default getDatePickerLocale;
